import thirPartPayBg from "../../../assets/image/store/whiteThirdBg.png"; 
import selectThirPay from "../../../assets/image/store/selectThirPay.png"; 
import selectInnerPay from "../../../assets/image/store/selectGooglePay.png"; 
import whiteProductSwitchBtn from "../../../assets/image/store/white-product-change.png"; 
import triangleDown from "../../../assets/image/icons/triangle-down.png"; 
import more from "../../../assets/image/icons/white-more.png"; 
import whiteMall from "../../../assets/image/store/white-mall-icon.png"; 
import whiteShopingCar from "../../../assets/image/store/blueShoppingCart.png"; 
import whiteMoney from "../../../assets/image/store/whiteMoney.png"; 
import payFailBg from "../../../assets/image/store/result-type-wrapper-red.png"; 
import paySuccessBg from "../../../assets/image/store/result-type-wrapper.png"; 
import paySuccess from "../../../assets/image/store/paySuccess.png"; 
import payStoring from "../../../assets/image/store/pay_storing.png"; 
import payFail from "../../../assets/image/store/payFail.png"; 
import playGameIcon from "../../../assets/image/icons/playGame.png"; 
import serviceIcon from "../../../assets/image/icons/service.png"; 
import switchIcon from "../../../assets/image/icons/switch.png"; 
import loadding from "../../../assets/image/icons/blueLoadding.png"; 
import bindIcon from "../../../assets/image/icons/bindIcon_blue.png"; 
import userIcon from "../../../assets/image/icons/user-icon-blue.png"; 
import tokenIcon from "../../../assets/image/icons/token-icon-blue.png"; 
import dmaIcon from "../../../assets/image/icons/dma-icon-blue.png"; 
import officialPayIcon from "../../../assets/image/icons/exchange-icon_blue.png"; 
import ellipsisIcon from "../../../assets/image/icons/feedback-icon-blue.png"; 
import textIcon from "../../../assets/image/icons/text-icon-blue.png"; 
import accountFollowIcon from "../../../assets/image/icons/setting-icon-blue.png"; 
import exchangeIcon from "../../../assets/image/icons/exchange-icon_blue.png"; 
import rewardIcon from "../../../assets/image/icons/reward-ico-blan.png"; 
import fundTermsIcon from "../../../assets/image/icons/fund-terms.png"; 
import survey from "../../../assets/image/icons/survey.png"; 
import deleteIcon from "../../../assets/image/icons/delete-blue.png"; 
import settingIcon from "../../../assets/image/icons/setting-icon-blue.png"; 
import selectHili from "../../../assets/image/icons/selectHili.png"; 
import closeBtn from "../../../assets/image/icons/closeBtn-blue.png"; 
import dialogblueBg from "../../../assets/image/icons/blueBg.png"; 
import loginBg from "../../../assets/image/webLogin/loginBg.png"; 
import userName from "../../../assets/image/icons/userName.png"; 
import password from "../../../assets/image/icons/password.png"; 
import blueStar from "../../../assets/image/support/blueStar.png"; 
import serviceDefaultAvatar from "../../../assets/image/support/potrait-service-blue.png"; 
import userDefaultAvatar from "../../../assets/image/support/potrait-user-blue.png"; 
import userInfoDefaultAvatar from "../../../assets/image/support/user-avatar-blue.png"; 
import supportSearchIcon from "../../../assets/image/support/search.png"; 
import subscribeIcon from "../../../assets/image/icons/subscribeIcon-icon-blue.png"; 
import subscribeItemGoDetail from "../../../assets/image/icons/subscribeIcon-icon-go-detail.png"; 
import appleDeleteIcon from "../../../assets/image/icons/apple-delete-blan.png"; 
import shortcutIcon from "../../../assets/image/icons/shortcut.png"; 
import serviceFloatIcon from "../../../assets/image/icons/service-float-icon-blanco.png"; 
let $lightBlue = '#c0dfff'
let $middleBlue = '#81acd9'
let $headerBg = '#e9f4ff'
let $testBorder = `1px solid ${$headerBg}`
let $selectTriggerBtn = {
  'border' : '1px solid #bcd5ef',
  'color' : $middleBlue,
  'padding' : '0 10px'
}
let $dialogScale = 550 / 736
let $dialogblueBgStyles = {
  'background-image' : `url( ${dialogblueBg})`,
  'background-repeat' : 'no-repeat',
  'background-position' : 'top center',
  'background-size' : '80%'
}
let $onestoreSubscribeItemStyles = {
  'display' : 'flex',
  'flex-direction' : 'column',
  'justify-content' : 'space-between',
  'height' : '190px',
  'border-radius' : '10px',
  'padding' : '26px 17px',
  'box-sizing' : 'border-box',
  'margin-top' : '23px',
  'transition' : 'none',
  'opacity' : '1'
}
let $storePayBtn = {
  'width' : '16px',
  'height' : '15px',
  'position' : 'absolute',
  'right' : '50px',
  'top' : '50%',
  'transform' : 'translateY(-50%)'
}
let $selectPayType = {
  'width' : '230px',
  'height' : '60px',
  'line-height' : '60px',
  'background-color' : 'transparent'
}
let $passportFunctionIconStyles = {
  'background-repeat' : 'no-repeat',
  'width' : '78px',
  'height' : '95px',
  'background-position' : 'center center',
  'background-size' : 'auto !important'
}
let $activeListItem = {
  'border' : `2px solid ${$middleBlue}`,
  'color' : $middleBlue
}
let $fillBtnVh = {
  'width' : '100%',
  'height' : '6vh',
  'line-height' : '6vh',
  'font-size' : '3vh',
  'background-color' : 'transparent'
}

let $noRpBg = function($img){ 
  return {
  'background-image' : `url( ${$img})`,
  'background-repeat' : 'no-repeat'
  }

}

  export default {
'vlink' : { 

 typeTheme :{ 
 'repaireAccountBtn' : { 
  'background-color' : '#c0dfff'
 
}} 
}
,
'button' : { 
  commonTheme : {
  'border-radius' : '30px',
  'font-size' : '32px',
  'height' : '60px',
  'line-height' : '60px',
  'color' : 'white',
  'background-color' : $lightBlue,
  'border' : '0',
  'cursor' : 'pointer'
  },
 typeTheme :{ 
 'repaireAccountApplyBtn' : { 
  'height' : '40px',
  'line-height' : '40px',
  'width' : '288px',
  'margin' : '50px auto 0',
  'font-size' : '18px',
  'color' : '#fff',
  'background-color' : '#c0dfff'
 
},
 'repaireAccountQueryBtn' : { 
  'height' : '40px',
  'line-height' : '40px',
  'width' : '288px',
  'margin' : '50px auto 0',
  'font-size' : '18px',
  'color' : '#fff',
  'background-color' : '#c0dfff'
 
},
 'markScoreMainClose' : { 
  'height' : '24px',
  'background-color' : 'transparent'
 
},
 'long' : { 
  'width' : '456px'
 
},
 'short' : { 
  'width' : '300px'
 
},
 'shortWidth' : { 
  'background' : 'transparent',
  'border' : '3px solid #c0dfff',
  'color' : '#c0dfff'
 
},
 'edit' : { 
  'width' : '170px',
  'height' : '80px'
 
},
 'fill' : { 
  'width' : '100%',
  'background-color' : $middleBlue
 
},
 'fillLightDialog' : { 
  'width' : '100%',
  'background-color' : $lightBlue,
  'border-radius' : '30px'
 
},
 'fillLight' : { 
  'width' : '100%',
  'background-color' : $lightBlue,
  'border-radius' : '30px'
 
},
 'fillLights' : { 
  'width' : '100%',
  'background-color' : $lightBlue,
  'border-radius' : '30px'
 
},
 'fillLightVh' : { 
  ...$fillBtnVh,
  'background-color' : $lightBlue,
  'border-radius' : '.8vh'
 
},
 'fillEmtyBorderVh' : { 
  ...$fillBtnVh,
  'color' : $lightBlue,
  'border' : `1px solid  ${$lightBlue}`,
  'border-radius' : '.8vh'
 
},
 'storeBtn' : { 
  'width' : '100%',
  'background-color' : '#9fc9f5',
  'margin-top' : '24px',
  'border-radius' : '0px'
 
},
 'bankInvoiceBtn' : { 
  'width' : '90%',
  'background-color' : '#9fc9f5'
 
},
 'refresh' : { 
  'background-color' : $lightBlue,
  'border-radius' : '0',
  'margin-left' : '0',
  'height' : '72px'
 
},
 'selectResetPwd' : { 
  'width' : '200px',
  'height' : '50px',
  'line-height' : '50px',
  'border-radius' : '0',
  'font-size' : '18px',
  'background-color' : $lightBlue
 
},
 'selectPayType' : { 
  ...$selectPayType,
  'background-image' : 'linear-gradient(to bottom , #7272f1, #5454df);'
 
},
 'selectInnerWay' : { 
  ...$selectPayType,
  'background-image' : 'linear-gradient(to bottom , #7fbeff, #5da3eb);'
 
},
 'switchProduct' : { 
  'background-image' : `url( ${whiteProductSwitchBtn})`,
  'width' : '56px',
  'height' : '56px',
  'background-color' : 'transparent',
  'border-radius' : '0'
 
},
 'returnGame' : { 
  'background-color' : '#9dc7fe',
  'height' : '80px',
  'line-height' : '80px',
  'border-radius' : '0'
 
},
 'reStore' : { 
  'background-color' : 'white',
  'height' : '80px',
  'line-height' : '80px',
  'border' : '1px solid #81acd9',
  'color' : '#81acd9',
  'border-radius' : '0'
 
},
 'swtichAccount' : { 
  'min-width' : '178px',
  'height' : '63px',
  'background' : '#b9dafb',
  'border-radius' : '30px',
  'border' : '0',
  'font-size' : '20px',
  'transform' : 'translateY(16px)',
  'padding' : '0 30px'
 
},
 'closeBtn' : { 
  'width' : '31px',
  'height' : '31px',
  'font-size' : 'initial',
  'background-image' : `url( ${closeBtn})`,
  'background-color' : 'transparent'
 
},
 'shortCancel' : { 
  'background-color' : 'white',
  'border' : '1px solid #81acd9',
  'line-height' : '60px',
  'height' : '60px',
  'width' : '210px',
  'color' : '#81acd9',
  'border-radius' : '30px'
 
},
 'shortConfirm' : { 
  'line-height' : '60px',
  'border' : '0',
  'height' : '60px',
  'width' : '210px',
  'color' : 'white',
  'border-radius' : '30px'
 
},
 'lightShort' : { 
  'font-size' : '24px'
 
},
 'grayShort' : { 
  'background' : '#ccc'
 
},
 'logoutBtn' : { 
  'background' : 'transparent',
  'height' : '4vh',
  'line-height' : '4vh',
  'font-size' : '1.8vh',
  'color' : '#7a7a7a',
  'padding' : '0',
  'border-radius' : '0',
  'border-bottom' : '1px solid #7a7a7a'
 
},
 'showServiceList' : { 
  'top' : '500px'
 
},
 'supportReturnGame' : { 
  'width' : '100%',
  'top' : '440px'
 
},
 'cancelSubscribe' : { 
  'width' : '100%',
  'height' : '64px',
  'line-height' : '64px',
  'border-radius' : '10px',
  'font-size' : '23.5px',
  'color' : '#fff',
  'background-color' : '#b4d7fb',
  'margin' : '78px auto 0'
 
}} 
}
,
'selectTriggerBtn' : { 
  commonTheme : {
  'height' : '40px',
  'line-height' : '40px',
  'background-color' : 'white'
  },
 typeTheme :{ 
 'locationSelect' : { 
  'width' : '268px',
  'border-radius' : '20px',
  ...$selectTriggerBtn
 
},
 'amountSelect' : { 
  ...$selectTriggerBtn,
  'width' : '278px',
  'float' : 'right'
 
},
 'bankSelect' : { 
  ...$selectTriggerBtn,
  'width' : '60%',
  'height' : '60px',
  'margin' : '0 auto',
  'text-align' : 'center'
 
}} 
}
,
'title' : { 
  commonTheme : {
  'color' : $middleBlue
  },
 typeTheme :{ 
 'articleTtile' : { 
  'font-size' : '36px'
 
},
 'dialogTitle' : { 
  'font-size' : '40px',
  'color' : '#414141',
  'margin-top' : '44px',
  'margin-bottom' : '33px'
 
},
 'switchTitle' : { 
  'font-size' : '40px',
  'color' : '#414141'
 
}} 
}
,
'headerContainer' : { 
  commonTheme : {
  'background' : $headerBg
  }}
,
'footerContainer' : { 
  commonTheme : {
  'padding-top' : '24px',
  'background' : $headerBg
  },
 typeTheme :{ 
 'supportFooter' : { 
  'height' : '130px'
 
}} 
}
,
'SelectGroup' : { 
  commonTheme : {
  'color' : $middleBlue,
  'border' : 'solid 1px #bcd5ef',
  'background' : 'white',
  'top' : '25px'
  },
 typeTheme :{ 
 'selectStoreInfo' : { 
  'width' : '100%',
  'height' : '4.2vh',
  'padding' : '0 2vh',
  'margin-bottom' : '1.7vh',
  'margin-left' : '0',
  'top' : '0',
  'border-radius' : '.8vh'
 
}} 
}
,
'select' : { 
  commonTheme : {
  'color' : $middleBlue,
  'border' : 'solid 1px #bcd5ef',
  'border-radius' : '.8vh',
  'background' : 'white',
  'top' : '25px'
  },
 typeTheme :{ 
 'selectStoreInfo' : { 
  'width' : '100%',
  'height' : '4.2vh',
  'padding' : '0 2vh',
  'margin-bottom' : '1.7vh',
  'margin-left' : '0',
  'top' : '0'
 
},
 'selectLang' : { 
  'margin-right' : '3vh',
  'top' : '0'
 
},
 'selectLangLogin' : { 
  'top' : '-6vh',
  'border-radius' : '.8vh'
 
}} 
}
,
'block' : { 

 typeTheme :{ 
 'payWayBtn' : { 
  'border' : `1px solid ${$middleBlue}`
 
},
 'line' : { 
  'background' : '#cee3f9'
 
},
 'price' : { 
  'background' : '#74b3f5'
 
},
 'storeOrder' : { 
  'background' : '#e9f4ff'
 
},
 'pageContainer' : { 
  'background' : '#e9f4ff'
 
},
 'storeOrderBorder' : { 
  'border-bottom' : '1px solid #c3def9'
 
},
 'funtionListItem' : { 
  'border-bottom' : '1px solid #d9e6f4',
  'display' : 'flex',
  'align-items' : 'center',
  'margin-bottom' : '0'
 
},
 'passportHeader' : { 
  'background' : 'white',
  'border-radius' : '12px',
  'box-shadow' : '1px 10px 10px #d9e8f8',
  'margin-bottom' : '0',
  'position' : 'relative',
  'z-index' : '2'
 
},
 'accountDialog' : { 
  ...$dialogblueBgStyles,
  'border-radius' : '12px'
 
},
 'accountDialogContainer' : { 
  'background-color' : 'transparent',
  'height' : `${$dialogScale} * 476 + px`
 
},
 'tipsDialogWrapper' : { 
  ...$dialogblueBgStyles,
  'background-color' : 'transparent'
 
},
 'loginTipsDialogWrapper' : { 
  ...$dialogblueBgStyles,
  'background-color' : 'white',
  'border-radius' : '.8vh',
  'border' : '0',
  'padding' : '1.4vh 1.5vh'
 
},
 'dialogBtnDocker' : { 
  'margin-bottom' : '20px'
 
},
 'tipsDialog' : { 
  'border-radius' : '12px'
 
},
 'accountSetting' : { 
  'background' : 'white',
  'padding-top' : '15px'
 
},
 'editorWrapper' : { 
  'background' : 'transparent'
 
},
 'countDown' : { 
  'background' : 'transparent',
  'display' : 'flex',
  'align-items' : 'center',
  'font-size' : '20px'
 
},
 'activeListItem' : { 
  ...$activeListItem
 
},
 'webLogin' : { 
  'background-color' : '#e9f4ff',
  'background' : 'radial-gradient(farthest-side at 50% 20%,#ffffff, #e9f4ff)'
 
},
 'bgHuawens' : { 
  'background-image' : `url( ${loginBg})`,
  'background-position' : 'top center',
  'background-repeat' : 'no-repeat',
  'top' : '0',
  'left' : '0',
  'width' : '100%',
  'height' : '100%'
 
},
 'loginBox' : { 
  'border-radius' : '1.8vh',
  'box-shadow' : '0 10px 10px #c9dbed',
  'background' : 'white',
  'background' : 'linear-gradient(#e9f4ff, 30%, white)',
  'padding-top' : '2vh',
  'background-size' : '100% 40vh',
  'background-repeat' : 'no-repeat',
  'background-color' : 'white'
 
},
 'gameSelectBox' : { 
  'background-color' : 'transparent'
 
},
 'gameSelectBoxStore' : { 
  'background-color' : 'transparent',
  'margin-top' : '0'
 
},
 'serviceSuccessPopup' : { 
  'border' : '0',
  'border-radius' : '1',
  ...$dialogblueBgStyles,
  'height' : '600px',
  'border-color' : 'white'
 
},
 'scoreBlock' : { 
  'width' : '591px',
  'height' : '568px',
  'background-color' : 'white',
  'background-image' : `url( ${dialogblueBg})`,
  'background-repeat' : 'no-repeat',
  'border-radius' : '16px'
 
},
 'maintainScoreImg' : { 
  'display' : 'block',
  'width' : '158px',
  'height' : '158px',
  'margin' : '80px auto 20px auto',
  'background-image' : `url( ${paySuccess})`,
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'scoreStartContainer' : { 
  'top' : '180px'
 
},
 'commentTips' : { 
  'top' : '250px'
 
},
 'loadding' : { 
  'background-image' : `url( ${loadding})`
 
},
 'onestoreSubscribePageContainer' : { 
  'position' : 'relative',
  'background' : '#fff',
  'padding' : '18px 24px'
 
},
 'subscribeManage' : { 
  'margin-bottom' : '45px'
 
},
 'subscribeManageDetail' : { 
  'margin-bottom' : '45px'
 
},
 'subscribeManageContent' : { 
  'min-height' : '92vh'
 
},
 'subscribeManageDetailContent' : { 
  'min-height' : '92vh'
 
},
 'onestoreSubscribePrivacy' : { 
  'display' : 'block',
  'text-align' : 'center',
  'font-size' : '22px',
  'color' : '#5d7c9d'
 
},
 'onestoreSubscribeDetailItem' : { 
  ...$onestoreSubscribeItemStyles,
  'height' : '142px',
  'background' : '#e9f4ff'
 
},
 'onestoreSubscribeTimeItem' : { 
  ...$onestoreSubscribeItemStyles,
  'padding' : '21px 17px',
  'height' : '102px',
  'background' : '#fff',
  'border' : '1px solid #dfdfdf'
 
},
 'onestoreSubscribeTimeItem-active' : { 
  ...$onestoreSubscribeItemStyles,
  'padding' : '21px 17px',
  'height' : '102px',
  'background' : '#fff',
  'border' : '1px solid #81acd9'
 
},
 'productItemPrice' : { 
  'color' : '#5698dc',
  'background' : '#eff7ff'
 
}} 
}
,
'blockClickable' : { 

 typeTheme :{ 
 'reselectRole' : { 
  'background' : '#bcd5ef',
  'color' : 'white',
  'border-radius' : '.8vh',
  'border-color' : '#bcd5ef'
 
},
 'productItem' : { 
  'border-radius' : '1.2vh',
  'border-color' : '#eaf4ff',
  'border-width' : '2px'
 
},
 'payWayDetail' : { 
  'border' : `1px solid ${$middleBlue}`
 
},
 'moreGameText' : { 
  'color' : $middleBlue
 
},
 'bankWayDetail' : { 
  'border' : `1px solid ${$middleBlue}`,
  'padding-right' : '30px',
  'flex-wrap' : 'wrap',
  'height' : 'auto'
 
},
 'onestoreSubscribeItem' : { 
  ...$onestoreSubscribeItemStyles,
  'background' : '#eaeef1'
 
},
 'onestoreSubscribeItem-active' : { 
  ...$onestoreSubscribeItemStyles,
  'background' : '#e9f4ff'
 
},
 'productTypeSelectItem' : { 
  'font-size' : '2vh',
  'line-height' : '4vh',
  'height' : '4vh',
  'background' : 'white',
  'color' : '#81acd9',
  'border' : '1px solid #bcd5ef',
  'border-radius' : '.8vh'
 
},
 'productTypeSelectItemCur' : { 
  'font-size' : '2vh',
  'line-height' : '4vh',
  'height' : '4vh',
  'background' : '#bcd5ef',
  'color' : 'white',
  'border' : '1px solid #bcd5ef',
  'border-radius' : '.8vh'
 
}} 
}
,
'add' : { 
  commonTheme : {
  'background-image' : 'url(data:image/png;base64,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);'
  }}
,
'content' : { 

 typeTheme :{ 
 'tipsContent' : { 
  'font-size' : '20px'
 
},
 'passportTips' : { 
  'border-bottom' : '1px solid #d5d5d5'
 
}} 
}
,
'mark' : { 
  commonTheme : {
  'color' : $middleBlue,
  'text-decoration' : 'underline'
  },
 typeTheme :{ 
 'thirdPartName' : { 
  'color' : '#4571ef',
  'text-decoration' : 'none'
 
},
 'amount' : { 
  'color' : '#de6262',
  'text-decoration' : 'none'
 
},
 'coinName' : { 
  'color' : '#414141',
  'text-decoration' : 'none'
 
},
 'subscribeTitle' : { 
  'color' : '#414141',
  'font-size' : '28px',
  'font-weight' : 'bolder',
  'text-decoration' : 'none'
 
},
 'subscribeItemTitle' : { 
  'color' : '#787878',
  'font-size' : '23.6px',
  'font-weight' : 'bolder',
  'text-decoration' : 'none'
 
},
 'subscribeItemTitle-active' : { 
  'color' : '#414141'
 
},
 'subscribeItemContent' : { 
  'display' : 'block',
  'color' : '#787878',
  'font-size' : '22px',
  'text-decoration' : 'none',
  'line-height' : '25px',
  'margin-bottom' : '17px',
  'overflow' : 'hidden',
  'text-overflow' : 'ellipsis',
  'white-space' : 'nowrap'
 
},
 'subscribeItemContent-active' : { 
  'color' : '#333'
 
},
 'subscribeItemTime' : { 
  'text-align' : 'center',
  'height' : '32px',
  'line-height' : '32px',
  'color' : '#798189',
  'font-size' : '20px',
  'text-decoration' : 'none',
  'background-color' : '#c9ced2',
  'border-radius' : '32px',
  'padding' : '7px 10px'
 
},
 'subscribeItemTime-active' : { 
  'color' : '#5d7c9d',
  'background-color' : '#cadff4'
 
},
 'expireTips' : { 
  'display' : 'block',
  'color' : '#787878',
  'font-size' : '22px',
  'text-decoration' : 'none',
  'margin' : '23px 0'
 
},
 'onestoreSubscribeTip' : { 
  'display' : 'block',
  'height' : '25px',
  'color' : '#999',
  'font-size' : '22px',
  'text-decoration' : 'none',
  'margin' : '78px 0',
  'text-align' : 'center',
  'line-height' : '25px'
 
},
 'subscribeItemProduct' : { 
  'display' : 'block',
  'color' : '#333',
  'font-size' : '23.6px',
  'font-weight' : 'bolder',
  'text-decoration' : 'none',
  'line-height' : '25px',
  'margin-bottom' : '17px',
  'overflow' : 'hidden',
  'text-overflow' : 'ellipsis',
  'white-space' : 'nowrap'
 
},
 'subscribeItemDesc' : { 
  'color' : '#5d7c9d',
  'font-size' : '20px',
  'text-decoration' : 'none'
 
},
 'subscribeItemDetailTime' : { 
  'color' : '#999',
  'font-size' : '20.5px',
  'text-decoration' : 'none'
 
},
 'subscribeItemDetailTitle' : { 
  'color' : '#333',
  'font-size' : '23.6px',
  'text-decoration' : 'none'
 
},
 'subscribeItemDetailPrices1' : { 
  'color' : '#333',
  'font-size' : '23.6px',
  'text-decoration' : 'none'
 
},
 'subscribeItemDetailPrices2' : { 
  'display' : 'none'
 
},
 'subscribeDetailTip' : { 
  'display' : 'inline-block',
  'font-size' : '22px',
  'color' : '#999',
  'line-height' : '28px',
  'text-decoration' : 'none',
  'margin-bottom' : '20px'
 
}} 
}
,
'supportReplyInput' : { 
  commonTheme : {
  'background-color' : 'white',
  'height' : '60px',
  'line-height' : '60px'
  }}
,
'icon' : { 

 typeTheme :{ 
 'appleDeleteIcon' : { 
  'background-image' : `url( ${appleDeleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'shortcutIcon' : { 
  'background-image' : `url( ${shortcutIcon})`,
  ...$passportFunctionIconStyles
 
},
 'searchType' : { 
  'background-image' : `url( ${supportSearchIcon})`,
  'width' : '25px',
  'height' : '26px'
 
},
 'commonHeaderBack' : { 
  'top' : '33px'
 
},
 'loginBtnLeft' : { 
  'display' : 'none'
 
},
 'loginBtnRight' : { 
  'display' : 'none'
 
},
 'loginBtnLeft2' : { 
  'display' : 'none'
 
},
 'loginBtnRight2' : { 
  'display' : 'none'
 
},
 'loginBoxLeftTop' : { 
  'display' : 'none'
 
},
 'loginBoxRightTop' : { 
  'display' : 'none'
 
},
 'loginBoxLeftBottom' : { 
  'display' : 'none'
 
},
 'loginBoxRightBottom' : { 
  'display' : 'none'
 
},
 'thirdPartNameIconLeft' : { 
  'display' : 'none'
 
},
 'thirdPartNameIconRight' : { 
  'display' : 'none'
 
},
 'resultBackBtnLeft' : { 
  'display' : 'none'
 
},
 'resultBackBtnRight' : { 
  'display' : 'none'
 
},
 'resultHistoryBtnLeft' : { 
  'display' : 'none'
 
},
 'resultHistoryBtnRight' : { 
  'display' : 'none'
 
},
 'supportReturnGameHelmet' : { 
  'display' : 'inline-block'
 
},
 'commonBtnLeft' : { 
  'display' : 'none'
 
},
 'commonBtnRight' : { 
  'display' : 'none'
 
},
 'createWorkBtnLeft' : { 
  'display' : 'none'
 
},
 'createWorkBtnRight' : { 
  'display' : 'none'
 
},
 'submitBtnCheck' : { 
  'display' : 'inline-block'
 
},
 'select' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAMAAABFyS02AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAb1BMVEUAAACBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNkAAAAvcOsnAAAAI3RSTlMALbcPwgoj47gGIirqrAMy8KABPPWTkkb5hFL8dl7+a2x6e1lW5/kAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAbElEQVQI112ORQ7AMAwEt5xiysz7/z82URUV5uLxWrINy3bwwrEtuHS9J/FUCz+gCE0SCgYRECdMszvJUiaxFpmzKLWUBXN5D6uaja4t68qs6HoOwMC+ew6NE+eZ0/h+Z1kVCz5s5I4fx2nsAmZ2Bl6CPGunAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTEyLTEwVDExOjAxOjUzKzA4OjAwUYCEIAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0xMi0xMFQxMTowMTo1MyswODowMCDdPJwAAAAASUVORK5CYII=);',
  'width' : '18px',
  'height' : '11px'
 
},
 'selectvh' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAMAAABFyS02AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAb1BMVEUAAACBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNkAAAAvcOsnAAAAI3RSTlMALbcPwgoj47gGIirqrAMy8KABPPWTkkb5hFL8dl7+a2x6e1lW5/kAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAbElEQVQI112ORQ7AMAwEt5xiysz7/z82URUV5uLxWrINy3bwwrEtuHS9J/FUCz+gCE0SCgYRECdMszvJUiaxFpmzKLWUBXN5D6uaja4t68qs6HoOwMC+ew6NE+eZ0/h+Z1kVCz5s5I4fx2nsAmZ2Bl6CPGunAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTEyLTEwVDExOjAxOjUzKzA4OjAwUYCEIAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0xMi0xMFQxMTowMTo1MyswODowMCDdPJwAAAAASUVORK5CYII=);',
  'width' : '1.8vh',
  'height' : '1.1vh',
  'background-size' : 'contain'
 
},
 'quession' : { 
  'background-image' : 'url(data:image/png;base64,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)',
  'width' : '40px',
  'height' : '40px'
 
},
 'quessionList' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACOlBMVEUAAACBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNna7P/a7P/a7P/a7P/a7P/a7P/a7P/a7P/a7P/a7P+BrNmBrNmBrNmyz+7a7P+BrNmBrNmBrNmlxujN4/ra7P+BrNmBrNmBrNmHsNza7P/a7P+BrNmBrNm/2fTa7P/a7P+BrNmBrNmIsdza7P+BrNmBrNmnyOna7P/a7P+BrNmBrNmBrNm+2PPa7P+BrNm+2PPa7P/a7P+BrNmBrNmryuvS5vuBrNmPtt+GsNuBrNmBrNmIsdyixOeDrdqBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNmBrNna7P/R5vvC2vXL4fijxeijxOfU5/zK4fjL4fnH3vfI3/fM4vm81/LZ6//V6P230/Cmx+m20vDC2/XN4vnB2vS10e8AAABDMG1kAAAApnRSTlMAMHKYu8+5lm8nXsa+UjfO7aNmOSg7aaj1wW3dBAlu6FeEiQIKmWt0bFMyVRnig6XCZLblXPY8S6KtceNdrDahagsRhpLp2K/arkcB+nlh7HCdHxgMzLT3KUDrHU/Z0SQpaJ/E2t3Rs4AzTMCrp9xopoL9qQmkZzj1wAoGFvyuActj72fyRePvFZ7KNeuGdvjtBlmM/FRz/Pc+0/74/i3Xf6rvx6cmGSbOkwAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAHRSURBVCjPbZP5Q01BFMeHeooIbeQpCZFEetZKhCJSSNay72TfU8leFEII2T9jr+zhj+tOd+be+6rzwznzPZ+5c+ecmRHCsQEDQ0J9vkFh4YNFXxsSgWNDh/WCkcNhxMio6JiY2LhRoyE+aIUx4I8aa1RC4jhIcul4SJ7gnT5xEqQYMTlorm1TINUeTYW0vlsNh2k9g3Sm91OJmEGGCjPxm0xSZiAQOsuo2cyxfIC5Ws+zq56vZZb6PJZsLXNgQWTuQlhk6zxYLJawVON8ClRYxnKdKCTHUitssTK+aJWKxZRovJo1ws9as5fSdcqXkal1GuvFBkq95eRZJ7NRjzfhE5vZ4u1mAZQbEU2F2Mo2sX3Hzl279+zdt/9AobeDBzkkDlN5RBp7D1nuUkc5Jo5zwqHyA5w85eDTnBFnOefij58+fzl/QdOqIi6qE6l2+dd2KWtqbRzHJcvXcdmhHdAh5RUbX+WaCtlcN7gTOqW8cVOl62nomXULbjuLf1O+0cqmYNrZBHek1+7es35Ms6ngPjwI4g/DoMVtgHUZH33/YeDPX4+xztJjT1rh6e8/XX/b//1/9hwy2nrdvLoX7iOKSO3nara9fFX2uuTN25Z3bq4baVPkeNob7jkAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMTItMTBUMTY6NDI6MTcrMDg6MDAHGGAQAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTEyLTEwVDE2OjQyOjE3KzA4OjAwdkXYrAAAAABJRU5ErkJggg==);',
  'width' : '30px',
  'height' : '30px'
 
},
 'selectList' : { 
  'background-image' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAMAAAC6q9RHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAeFBMVEUAAADKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysoAAACuFEHbAAAAJnRSTlMAK8MguuMoD+oyCrnwPAau9UYDn/lRAZL8XYT+anZ4e2vr5SnFIZBzHKMAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAXElEQVQI12WONw7AMAwDbaf33nvj/5+YLEwMRBMPkE4UUhmCY8KymR0F1yP4AcKIECdIM0JeoKwIdYO2e209hvGFacCs5eXbWX+3mlP7pXV4um3sZmI/KJbnxXgDrIgG2U2of2oAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMTItMTBUMTc6MjM6NDIrMDg6MDDHITkrAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTEyLTEwVDE3OjIzOjQyKzA4OjAwtnyBlwAAAABJRU5ErkJggg==)',
  'width' : '11px',
  'height' : '18px'
 
},
 'quessionSelect' : { 
  'border-top-color' : $middleBlue
 
},
 'selectThirPay' : { 
  'background-image' : `url( ${selectThirPay})`,
  ...$storePayBtn
 
},
 'selectInnerPay' : { 
  'background-image' : `url( ${selectInnerPay})`,
  ...$storePayBtn
 
},
 'selectTrigger' : { 
  'width' : '18px',
  'height' : '11px',
  'border' : 'none',
  'background-image' : `url( ${triangleDown})`
 
},
 'more' : { 
  'background-image' : `url( ${more})`
 
},
 'before' : { 
  'border-right-color' : '#74b3f5'
 
},
 'global' : { 
  'background-image' : `url( ${whiteMall})`
 
},
 'shoppingCar' : { 
  'background-image' : `url( ${whiteShopingCar})`,
  'border-top' : '0'
 
},
 'whiteMoney' : { 
  ...$noRpBg(whiteMoney)
 
},
 'storesuccess' : { 
  'background-image' : `url( ${paySuccess})`,
  'background-repeat' : 'no-repeat'
 
},
 'storefail' : { 
  'background-image' : `url( ${payFail})`,
  'background-repeat' : 'no-repeat'
 
},
 'storestoring' : { 
  'background-image' : `url( ${payStoring})`,
  'background-repeat' : 'no-repeat'
 
},
 'playGame' : { 
  'background-image' : `url( ${playGameIcon})`,
  'background-repeat' : 'no-repeat',
  'width' : '37px',
  'height' : '33px',
  'margin-right' : '10px'
 
},
 'service' : { 
  'background-image' : `url( ${serviceIcon})`,
  'background-repeat' : 'no-repeat',
  'width' : '30px',
  'height' : '36px',
  'margin-right' : '10px'
 
},
 'switch' : { 
  'background-image' : `url( ${switchIcon})`,
  'background-repeat' : 'no-repeat',
  'width' : '22px',
  'height' : '16px'
 
},
 'bindIcon' : { 
  'background-image' : `url( ${bindIcon})`,
  ...$passportFunctionIconStyles
 
},
 'userIcon' : { 
  'background-image' : `url( ${userIcon})`,
  ...$passportFunctionIconStyles
 
},
 'tokenIcon' : { 
  'background-image' : `url( ${tokenIcon})`,
  ...$passportFunctionIconStyles
 
},
 'dmaIcon' : { 
  'background-image' : `url( ${dmaIcon})`,
  ...$passportFunctionIconStyles
 
},
 'officialPayIcon' : { 
  'background-image' : `url( ${officialPayIcon})`,
  ...$passportFunctionIconStyles
 
},
 'ellipsisIcon' : { 
  'background-image' : `url( ${ellipsisIcon})`,
  ...$passportFunctionIconStyles
 
},
 'textIcon' : { 
  'background-image' : `url( ${textIcon})`,
  ...$passportFunctionIconStyles
 
},
 'subscribeIcon' : { 
  'background-image' : `url( ${subscribeIcon})`,
  ...$passportFunctionIconStyles
 
},
 'accountFollowIcon' : { 
  'background-image' : `url( ${accountFollowIcon})`,
  ...$passportFunctionIconStyles
 
},
 'exchangeIcon' : { 
  'background-image' : `url( ${exchangeIcon})`,
  ...$passportFunctionIconStyles
 
},
 'rewardIcon' : { 
  'background-image' : `url( ${rewardIcon})`,
  ...$passportFunctionIconStyles
 
},
 'fundTermsIcon' : { 
  'background-image' : `url( ${fundTermsIcon})`,
  ...$passportFunctionIconStyles
 
},
 'survey' : { 
  'background-image' : `url( ${survey})`,
  ...$passportFunctionIconStyles
 
},
 'deleteIcon' : { 
  'background-image' : `url( ${deleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'settingIcon' : { 
  'background-image' : `url( ${deleteIcon})`,
  ...$passportFunctionIconStyles
 
},
 'selectHili' : { 
  'background-image' : `url( ${selectHili})`,
  'background-repeat' : 'no-repeat',
  'width' : '14px',
  'height' : '26px',
  'margin-right' : '0'
 
},
 'userName' : { 
  'background-image' : `url( ${userName})`,
  'width' : '2.8vh',
  'height' : '3.3vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'password' : { 
  'background-image' : `url( ${password})`,
  'width' : '2.7vh',
  'height' : '2.9vh',
  'background-repeat' : 'no-repeat',
  'background-size' : 'cover'
 
},
 'helmet' : { 
  'display' : 'none'
 
},
 'folder' : { 
  'display' : 'none'
 
},
 'service' : { 
  'background-image' : `url( ${serviceIcon})`,
  'width' : '30px',
  'height' : '36px'
 
},
 'serviceDefaultAvatar' : { 
  'background-image' : `url( ${serviceDefaultAvatar})`
 
},
 'userDefaultAvatar' : { 
  'background-image' : `url( ${userDefaultAvatar})`
 
},
 'userInfoDefaultAvatar' : { 
  'background-image' : `url( ${userInfoDefaultAvatar})`
 
},
 'line' : { 
  'background-color' : '#9dc8f3'
 
},
 'custom' : { 
  'color' : '#9dc8f3'
 
},
 'showChildpayTypeIcon' : { 
  'background-image' : `url( ${more})`
 
},
 'storeBtnLeft' : { 
  'display' : 'none'
 
},
 'storeBtnRight' : { 
  'display' : 'none'
 
},
 'subscribeItemGoDetail' : { 
  'display' : 'inline-black',
  'width' : '13px',
  'height' : '23px',
  'background-image' : `url( ${subscribeItemGoDetail})`
 
}} 
}
,
'payState' : { 

 typeTheme :{ 
 'success' : { 
  'background-image' : `url( ${paySuccessBg})`
 
},
 'fail' : { 
  'background-image' : `url( ${payFailBg})`
 
}} 
}
,
'listItem' : { 

 typeTheme :{ 
 'active' : { 
  ...$activeListItem
 
},
 'selectItem' : { 
  'border' : '1px solid #bfbfbf',
  'padding-left' : '70px'
 
},
 'selectItem-active' : { 
  'border-color' : $middleBlue
 
},
 'functionItem' : { 
  'padding-right' : '48px',
  'padding-left' : '76px',
  'background' : 'transparent',
  'display' : 'flex',
  'align-items' : 'center'
 
},
 'accountSettingItem' : { 
  'padding-right' : '48px',
  'padding-left' : '26px',
  'background' : 'transparent',
  'display' : 'flex',
  'align-items' : 'center'
 
},
 'locationItem' : { 
  'height' : '80px'
 
},
 'productSelectOptions' : { 
  'text-align' : 'left'
 
},
 'paymentItem' : { 
  'height' : '80px'
 
}} 
}
,
'thirPartPay' : { 
  commonTheme : {
  'background-image' : `url( ${thirPartPayBg})`,
  'border-radius' : '16px'
  }}
,
'innerPay' : { 
  commonTheme : {
  'border-radius' : '16px'
  },
 typeTheme :{ 
 'oneStore' : { 
  'background' : 'black'
 
}} 
}
,
'list' : { 

 typeTheme :{ 
 'passportFunctionList' : { 
  'display' : 'inline-block',
  'padding' : '76px 45px 76px 22px',
  'background' : 'white',
  'border-radius' : '12px',
  'box-sizing' : 'border-box',
  'margin-top' : '-62px',
  'margin-bottom' : '20px'
 
}} 
}
,
'editor' : { 

 typeTheme :{ 
 'passportAccountEditor' : { 
  'background' : 'transparent'
 
},
 'loginEditor' : { 
  'border-color' : $middleBlue,
  'border-radius' : '.8vh'
 
}} 
}
,
'scoreStart' : { 

 typeTheme :{ 
 'active' : { 
  'background-image' : `url( ${blueStar})`,
  'background-repeat' : 'no-repeat'
 
}} 
}
,
'typeCategory' : { 
  commonTheme : {
  'color' : $middleBlue
  }}
,
'bankText' : { 
  commonTheme : {
  'color' : '#2592ff'
  }}
,
'bankTotal' : { 
  commonTheme : {
  'border-color' : '#bcd5ef',
  'color' : '#414141'
  }}

}